/**
 * Was gelang — die Stelle, an der jede Seite eine gelungene Speicherung meldet
 * (7.2 Abschnitt 34, R1130–R1132).
 *
 * **Eine Stelle für alle Seiten, wie die Störungen** (`Stoerungsstelle.ts`):
 * Bis zum 2026-10-06 bestätigte jede Seite auf ihre Art, meist als graue Zeile
 * über der Liste — *„28 Zeilen übernommen — Tochter USA, September 2026."* —
 * im selben Grau wie jeder Hinweis. Jetzt ruft sie `meldeErfolg`, und das
 * Kästchen oben rechts zeigt es.
 */

/**
 * Eine Aufforderung, die an der Speicherung hängt (R1132) — mit dem Knopf,
 * der zum Weg führt. Dann bleibt das Kästchen, bis es geschlossen wird.
 */
export type Aufforderung = {
  satz: string
  knopf: string
  aufKnopf: () => void
}

export type Erfolg = {
  /** Die Tat und ihr Gegenstand, sonst nichts (R1131) — „Datenimport erfolgreich gespeichert". */
  satz: string
  aufforderungen: Aufforderung[]
  /** Damit dasselbe Kästchen zweimal hintereinander als neues gilt. */
  nummer: number
}

let aktuell: Erfolg | null = null
let naechste = 0
const hoerer = new Set<() => void>()

function aendern(neu: Erfolg | null) {
  aktuell = neu
  for (const h of hoerer) {
    h()
  }
}

/** Meldet eine gelungene Speicherung. Ein zweites Kästchen ersetzt das erste. */
export function meldeErfolg(satz: string, aufforderungen: Aufforderung[] = []): void {
  aendern({ satz, aufforderungen, nummer: ++naechste })
}

export function schliesseErfolg(): void {
  aendern(null)
}

export function erfolg(): Erfolg | null {
  return aktuell
}

export function abonniereErfolg(h: () => void): () => void {
  hoerer.add(h)
  return () => {
    hoerer.delete(h)
  }
}

/** Wie lange das Kästchen ohne Aufforderung steht (R1130). */
export const STANDZEIT_MS = 5000
